// components/admin/IconRail.jsx
import { NavLink } from "react-router-dom";
import { HomeIcon, UsersIcon, TableIcon, CogIcon } from "./Icon";

const items = [
  { to: "/admin", icon: HomeIcon, label: "회원등록" },
  { to: "/admin/members/update", icon: UsersIcon, label: "회원수정" },
  { to: "/admin/measurements", icon: TableIcon, label: "측정데이터" },
  { to: "/admin/workout-settings", icon: CogIcon, label: "운동설정" },
];

export default function IconRail() {
  return (
    <aside
      className={[
        "bg-gradient-to-b from-sky-500 to-blue-600 text-white sticky top-0 z-40 shrink-0",
        "w-full h-14 px-2 flex items-center border-b border-white/10",
        "md:w-14 md:h-screen  md:px-0 md:py-4 md:flex md:flex-col md:items-center md:border-b-0",
      ].join(" ")}
    >
      <div className="font-extrabold text-sm tracking-tight pl-1 md:pb-5 md:pl-0 md:pt-2">
        Scifit
      </div>

      <nav className="ml-auto flex items-center gap-2 md:ml-0 md:flex-1 md:flex md:flex-col md:items-center md:gap-2">
        {items.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            end
            title={label}
            className={({ isActive }) =>
              [
                "w-10 h-10 grid place-items-center rounded-xl transition-colors",
                isActive ? "bg-white/25 ring-2 ring-white/60" : "hover:bg-white/15",
              ].join(" ")
            }
          >
            <Icon className="w-5 h-5" />
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
